export const CirclingArrow = ({ ...props }) => {
    return (
        <svg width="14" height="16" viewBox="0 0 14 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fillRule="evenodd" clipRule="evenodd" d="M0.5 6.65789V7.11973C0.5 7.28978 0.634315 7.42763 0.8 7.42763H1.825C1.99069 7.42763 2.125 7.28978 2.125 7.11973V6.65789C2.125 4.11083 4.31144 2.03947 7 2.03947C9.68856 2.03947 11.875 4.11083 11.875 6.65789C11.875 9.20495 9.68856 11.2763 7 11.2763H6.1875V8.90059C6.1875 8.63218 5.87619 8.49229 5.68402 8.67435L2.125 12.046L5.68402 15.4177C5.87619 15.5998 6.1875 15.4599 6.1875 15.1915V12.8158H7C10.5839 12.8158 13.5 10.0532 13.5 6.65789C13.5 3.26258 10.5839 0.5 7 0.5C3.41606 0.5 0.5 3.26258 0.5 6.65789Z" fill="#9E00FF" />
        </svg>

    );
};
